import {useInfiniteQuery} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {useEffect} from 'react'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

const BATCH_SIZE = 25

export default function useFaceDetections({companyIds, faceIds, id}: {id?: number; faceIds?: Array<number>; companyIds: Array<number>}) {
  const {enqueueSnackbar} = useSnackbar()

  const infiniteQuery = useInfiniteQuery({
    retry: 0,
    refetchOnWindowFocus: false,
    initialPageParam: 0,
    queryKey: [QueryKeyEnum.FACE_DETECTIONS, companyIds, faceIds, id],
    queryFn: async ({pageParam: nextId}) => {
      if (nextId === -1) throw new Error('No more pages to fetch')

      const response = await api.events.getFaceDetections({
        batchSize: BATCH_SIZE,
        includes: ['face', 'faceDetectionsHaveActions', 'face.faceImages'],
        orderBy: {createdAt: 'DESC'},
        filter: {companyIds, faceIds, id},
        startId: nextId === 0 ? undefined : nextId,
      })

      return response
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage && allPages && allPages.some((c) => c && c.data.data.items.some((detection) => detection.id === lastPage.data.data.nextId))) {
        return null
      }

      return lastPage ? lastPage.data.data.nextId : undefined
    },
    throwOnError: () => {
      return false
    },
  })

  useEffect(() => {
    if (infiniteQuery.error) handleErrorWithSnackbar(enqueueSnackbar, infiniteQuery.error, 'Falha ao histórico de detecções faciais')
  }, [infiniteQuery.error])

  return infiniteQuery
}
